<script setup lang="ts">
// Mock of the real recorder screen; a real testimonial clip stands in for the camera.
import { useElementVisibility, useIntervalFn } from '@vueuse/core'
import { testimonials } from './landing-content'
import LandingVideo from './LandingVideo.vue'

const props = withDefaults(defineProps<{ clip?: number }>(), { clip: 2 })

const questions = ['Расскажи о себе', 'Почему хочешь у нас работать?', 'Когда тебе удобно работать?']
const LIMIT = 30

const root = useTemplateRef<HTMLElement>('root')
const visible = useElementVisibility(root)
const seconds = ref(0)
const question = computed(() => questions[Math.floor(seconds.value / 10) % questions.length])

const { pause, resume } = useIntervalFn(() => {
  seconds.value = (seconds.value + 1) % LIMIT
}, 1000, { immediate: false })
watch(visible, value => value ? resume() : pause())
</script>

<template>
  <div ref="root" class="relative flex size-full flex-col bg-black text-white">
    <div class="flex h-[50px] mt-8 shrink-0 items-center justify-between px-3 text-[17px] tabular-nums">
      <Icon name="tabler:chevron-left" class="size-6" />
      <span class="flex items-center gap-1.5">
        <span class="size-2 animate-pulse rounded-full bg-destructive" />
        0:{{ String(seconds).padStart(2, '0') }}
      </span>
      <span class="size-6" />
    </div>
    <div class="relative flex-1 overflow-hidden">
      <LandingVideo :src="testimonials[props.clip]!.src" class="absolute inset-0 size-full object-cover" />
      <div class="absolute inset-x-3 bottom-4 rounded-[10px] bg-black/30 px-3 py-2 text-[21px] font-semibold leading-tight backdrop-blur-sm">
        <Transition mode="out-in" enter-from-class="opacity-0 translate-y-2" leave-to-class="opacity-0 -translate-y-2" enter-active-class="transition duration-300" leave-active-class="transition duration-200">
          <p :key="question">{{ question }}</p>
        </Transition>
      </div>
    </div>
    <div class="h-1 shrink-0 bg-white/20">
      <div class="h-full bg-destructive transition-[width] duration-1000 ease-linear" :style="{ width: `${(seconds / LIMIT) * 100}%` }" />
    </div>
    <div class="flex h-28 shrink-0 items-center justify-center gap-10">
      <span class="size-12" />
      <span class="flex size-[70px] items-center justify-center rounded-full border-2 border-white">
        <span class="size-6 rounded-[4px] bg-destructive" />
      </span>
      <span class="flex size-12 items-center justify-center rounded-full bg-white/15">
        <Icon name="tabler:upload" class="size-5" />
      </span>
    </div>
  </div>
</template>
